module.exports = __webpack_public_path__ + "assets/images/default-8672e91aac2219d889e83a48c4f07349.jpg";